export default (block) => {
  if (block.author && block.author.content) {
    block.authorName = block.author.content.name
    block.authorTitle = block.author.content.title
    block.authorBio = block.author.content.bio
    block.authorPhoto = block.author.content.photo
  }
  return block
}
